import script from "./ContactSelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContactSelector.vue?vue&type=script&lang=ts&setup=true"
/* custom blocks */
import block0 from "./ContactSelector.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


const __exports__ = script;

export default __exports__